<template>
  <div class="text-[.385rem]">
    <Header :title="title" :showBack="true"></Header>
    <form action="">
      <div class="form_item">
        <span>日期：</span>
        <div class="form_input" @click.stop="$refs.calendar.show = true">
          {{ form.beginDate }} ~ {{ form.endDate }}
        </div>
      </div>
      <div class="form_item">
        <label for="">线路：</label>
        <div class="form_input text-row1" @click.stop="onLineSelectShow">
          {{ form.lineNameList.toString() }}
        </div>
        <button class="search_btn w-1/4" type="button" @click="doQuery">
          查询
        </button>
      </div>
    </form>
    <van-list
      class="m-1"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="stats_panel mt-1" v-for="(item, index) in list" :key="index">
        <p>
          <span>线路名称：</span>
          <b>{{ item.lineName }}</b>
        </p>
        <table class="class_table" border="1">
          <tr>
            <th>日期</th>
            <th>时间</th>
            <th>人数</th>
            <th>座位数</th>
            <th>客座率</th>
          </tr>
          <tr
            v-for="(citem, cindex) in item.classList"
            :key="cindex"
            :style="{
              background: cindex % 2 == 1 ? '#fff7d7' : 'default',
            }"
          >
            <td>{{ citem.ClassDate }}</td>
            <td>{{ citem.ClassTime }}</td>
            <td>{{ citem.CheckCount }}</td>
            <td>{{ citem.SeatCount }}</td>
            <td>{{ citem.AttendanceRatio }}</td>
          </tr>
        </table>
      </div>
    </van-list>
    <!-- 日历组件 -->
    <Calendar
      ref="calendar"
      type="range"
      :allow-same-day="true"
      @confirm="onConfirm"
    ></Calendar>
    <!-- 线路弹窗 -->
    <van-popup
      v-model="lineShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-checkbox-group v-model="form.lineGIDList">
        <van-checkbox
          :name="item.LineGID"
          shape="square"
          v-for="(item, index) in lineList"
          :key="index"
          >{{ item.LineName }}</van-checkbox
        >
      </van-checkbox-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectLine"
        >确认</van-button
      >
    </van-popup>
  </div>
</template>

<script>
import "@/views/AnalysisStats/style.less";
import Header from "@/components/Header/Header.vue";
import Calendar from "../../components/calendar.vue";
export default {
  components: {
    Header,
    Calendar,
  },
  data() {
    let now = new Date();
    return {
      title: "检票统计",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")),
      loading: false,
      finished: false,
      form: {
        beginDate: this.$moment(now).format("YYYY-MM-DD"),
        endDate: this.$moment(now).format("YYYY-MM-DD"),
        lineNameList: [],
        lineGIDList: [],
      },
      start: 0,
      limit: 5,
      list: [],
      totalData: {
        TotalCheckCount: 0,
        TotalClassCount: 0,
      },
      beginDateShow: false,
      endDateShow: false,
      lineShow: false,
      lineList: [],
    };
  },
  methods: {
    doQuery() {
      this.list = [];
      this.start = 0;
      this.finished = false;
    },
    async onLineSelectShow() {
      if (this.lineList.length <= 0) {
        await this.$http
          .post(this.$api.getGetCompLine, {
            OrganizationGID: this.operObj.OrganizationGID,
          })
          .then((res) => {
            this.lineList = res.data;
          });
      }
      this.lineShow = true;
    },
    onSelectLine() {
      this.form.lineNameList = this.lineList
        .filter((v) => this.form.lineGIDList.some((g) => g == v.LineGID))
        .map((v) => v.LineName);
      console.log(this.form);
      this.lineShow = false;
    },
    onLoad() {
      this.$http
        .post(this.$api.HandheldStatAttendanceRatioQuery, {
          BeginDate: this.$moment(this.form.beginDate).format(
            "YYYY-MM-DD 00:00:00"
          ),
          EndDate: this.$moment(this.form.endDate).format(
            "YYYY-MM-DD 23:59:59"
          ),
          LineGIDList: this.form.lineGIDList.toString(),
        })
        .then((res) => {
          const list = res.data;
          console.log(list);
          this.list = Array.from(new Set(list.map((d) => d.LineGID))).map(
            (v) => {
              console.log(v);
              let lineName;
              list
                .filter((d) => d.LineGID == v)
                .map((d) => {
                  d.ClassDate = this.$moment(d.ClassDate).format("YYYY-MM-DD");
                  d.SeatCount = d.SeatCount ? d.SeatCount : 0;
                  d.CheckCount = d.CheckCount ? d.CheckCount : 0;
                  lineName = d.LineName;
                  return d;
                });
              return {
                lineGID: v,
                lineName: lineName,
                classList: list.filter((d) => d.LineGID == v),
              };
            }
          );
          this.loading = false;
          this.finished = true;
          console.log(this.list);
        });
    },
    onConfirm(e) {
      this.form.beginDate = this.$moment(e[0]).format("YYYY-MM-DD");
      this.form.endDate = this.$moment(e[1]).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="less" scoped>
.class_table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin-top: 0.267rem;

  th,
  td {
    padding: 0.053rem;
  }
}

.van-popup {
  .van-checkbox {
    margin: 0.267rem;
  }

  .van-button {
    font-size: 0.533rem;
  }
}
</style>
